import { Component, Vue, Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import store from '@/store/store';

import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import EditableTableColumn from '@/../bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import AdmissaoController from '@/assets/ts/controller/AdmissaoController';
import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import NovaAdmissaoPopup from '@/components/admissao/NovaAdmissaoPopup/NovaAdmissaoPopup.vue';
import Action from '@/../bower_components/teknisavuecomponents/assets/interfaces/Action';
import Messages from '@/assets/ts/utils/Messages';
import Util from '@/assets/ts/utils/Util';
import { ControleAcessoWrapper } from '@/assets/ts/controller/ControleAcessoController';

@Component({
    name: 'Admissao',
    components: {
      EditableTable,
      NovaAdmissaoPopup,
    },
})
class Admissao extends Vue {
  // #region [ STORE ]
  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  private get user(): any {
    return this.$store.getters.user;
  }

  @Mutation('changeCurrentView')
  private changeCurrentView: (string) => void;

  @Mutation('setSolicitacao')
  private setSolicitacao: any;
  // #endregion

  // #region [ DATA ]
  private readonly viewTitle = 'Admissão';

  private admissoes: any[] = [];

  private loading = false;

  private toolbarActions: ToolbarAction[] = [
    {
      name: 'reload',
      label: 'Atualizar',
      icon: 'mdi-refresh',
      onClick: this.reload,
    },
    {
      name: 'add',
      label: 'Adicionar',
      icon: 'mdi-plus-circle',
      menu: true,
      condition: Util.isIDTrue(this.user.idrealizaadmissao),
      items: [
        {
          name: 'addSimplificado',
          label: 'Admissão Simplificada',
          onClick: ControleAcessoWrapper.criar(this.addSimplificado),
        },
        {
          name: 'addCompleto',
          label: 'Admissão Completa',
          onClick: ControleAcessoWrapper.criar(this.addCompleto),
        },
      ],
    },
  ];

  private columns: EditableTableColumn[] = [
    {
      text: 'Nr. Vínculo',
      value: 'NRVINCULOM',
      type: 'text',
    },
    {
      text: 'Nome',
      value: 'NMPESSOA',
      type: 'text',
    },
    {
      text: 'Tipo de Vínculo',
      value: 'NMTIPOVINCULOH',
      type: 'text',
    },
    {
      text: 'Estrutura Gerencial',
      value: 'NMESTRUTGEREN',
      type: 'text',
    },
    {
      text: 'Estrutura Legal',
      value: 'NMESTRUTLEGAL',
      type: 'text',
    },
    {
      text: 'Estrutura Sindical',
      value: 'NMESTRUTSIND',
      type: 'text',
    },
  ];

  private actions: Action[] = [
    // {
    //   name: 'view',
    //   label: 'Visualizar',
    //   icon: 'mdi-eye',
    //   onClick: this.viewAdmissao,
    //   mode: 'view',
    // },
  ];

  private novaAdmissao = {
    show: false,
    mode: 'edit',
    row: {},
    tipoAdmissao: 'simplificada',
  };
  // #endregion

  // #region [ COMPUTED ]
  private get isDP(): boolean {
    return this.user.dp;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.changeCurrentView(this.viewTitle);
    this.handleRedirectSolicitacaoAdmissao();
    (window as any).admissao = this;
  }

  private mounted() {
    this.reload();
    if (!Util.isIDTrue(this.user.idrealizaadmissao)) {
      SnackbarUtils.showMessage(Messages.ADMS_GESTOR_NAO_AUTORIZADO, SnackbarUtils.TYPE_ALERT);
    }
  }

  private destroyed() {
    const solicitacao = {
      NRSOLICITACAO: null,
      NRTIPOSOLICITACAO: null,
      NRVINCULOM: null,
    }

    this.setSolicitacao(solicitacao);
  }

  // #endregion

  // #region [ WATCHERS ]
  @Watch('estruturaGerencialAtual')
  private estruturaOnChange() {
    if (!this.isDP) {
      this.reload();
    }
  }
  // #endregion

  // #region [ METHODS ]
  private async reload() {
    this.loading = true;
    this.admissoes = [];

    try {
      const admissoes = await AdmissaoController.getVinculosNaoAprovados(false);
      this.admissoes = admissoes;
    } catch (err) {
      let message = '';
      let err2 = err as any;

      if (err2.name === 'ExpectedError') {
        message = err2.message;
        message = message.replace('(HCMSERVICES) ', '');
      } else {
        message = 'Não foi possível carregar as admissões!';
      }

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    } finally {
      this.loading = false;
    }
  }

  private async addSimplificado() {
    this.novaAdmissao.show = true;
    this.novaAdmissao.mode = 'edit';
    this.novaAdmissao.row = {};
    this.novaAdmissao.tipoAdmissao = 'simplificada';
  }

  private async addCompleto() {
    this.novaAdmissao.show = true;
    this.novaAdmissao.mode = 'edit';
    this.novaAdmissao.row = {};
    this.novaAdmissao.tipoAdmissao = 'completa';
  }

  private viewAdmissao(row: any) {
    this.novaAdmissao.show = true;
    this.novaAdmissao.mode = 'view';
    this.novaAdmissao.row = row;
  }

  private searchCpfEnd(value: any) {
    console.log(value);
  }

  private afterSave() {
    this.reload();
  }


  private handleRedirectSolicitacaoAdmissao() {
    const solicitacao = store.getters.solicitacao;

    if(solicitacao.NRSOLICITACAO) {
      this.addCompleto();
    }
  }
  // #endregion
}

export default Admissao;

